import { render } from "./NavBar2.vue?vue&type=template&id=e6dd4d76"
import script from "./NavBar2.vue?vue&type=script&lang=js"
export * from "./NavBar2.vue?vue&type=script&lang=js"

import "./NavBar2.vue?vue&type=style&index=0&id=e6dd4d76&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\doc\\MedRemind Project\\medremind-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__